'use client'

import { getCookie } from 'cookies-next';
import { redirect } from 'next/navigation';

export const getCurrentBearerTokenOrRedirectToLogin = (): string => {
    const token = getCookie('auth_token');
    if (!token) {
        redirect('/login');
    }
    return token ? String(token) : '';
}

export const getCurrentBearerToken = (): string => {
    const token = getCookie('auth_token');
    return token ? String(token) : '';
}

export const redirectToLogin = (router: any): void => {
    if (router && router.push) {
        router.push('/login');
    } else {
        location.href = '/login';
    }
}